import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomFilterPipe } from "./custom-filter.pipe";
import { PhonePipe } from "./phone.pipe";
import { SafePipe } from "./safe.pipe";
import { IdentificationPipe } from "./identification.pipe";
import { SplitFilterPipe } from "./split-filter.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [
    CustomFilterPipe,
    PhonePipe,
    SafePipe,
    IdentificationPipe,
    SplitFilterPipe
  ],
  exports: [
    CustomFilterPipe,
    PhonePipe,
    SafePipe,
    IdentificationPipe,
    SplitFilterPipe
  ]
})
export class PipeModule {}
